import styled from "styled-components";

export const DonationProcessBarContainer = styled.div`
  @media (max-width: 750px) {
    display: none;
  }
`

export const DonationProcessBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;  
  margin-bottom: 60px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 751px) {
    height: 150px;
    flex-direction: row;
    justify-content: space-between; 
  }

  @media (max-width: 750px) {
    width: 50px;
    flex-direction: column;
    justify-content: space-between; 
    align-items: center;
  }
`

export const DonationProcessBarCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const DonationProcessP = styled.p`
  margin-left: auto;
  margin-right: auto;
  margin-top: 5px;
  font-size: var(--font-size-sm);
`

export const IconCircleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-primary);
  border-radius: 50%;
  border: solid 5px var(--color-primary);
  font-size: 50px;
  width: 90px;
  height: 90px;
`

export const DottedLine = styled.div`
  height: 0;

  @media (min-width: 751px) {
    width: 5.5vw;
    border-top: dashed 5px var(--color-primary);
  }

  @media (max-width: 750px) {
    height: 5.5vw;
    border-left: dashed 2.5px var(--color-primary);
    border-right: dashed 2.5px var(--color-primary);
  }
`

export const DonationProcessBarH2 = styled.h2`
  margin-bottom: 20px;
`